import { Layout } from "@/components/layout/Layout";
import { CGVPageContentApiResponse } from "@/components/pages/cgv/Cgv";
import { queryCgv } from "@/strapiQuery/cgv";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiEntity } from "@/utils/strapi";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const intlMessages = loadIntlMessages(ctx);
  const layoutPromise = getStrapiEntity<Layout>("layout", "");

  const cgvPageContentPromise = getStrapiEntity<CGVPageContentApiResponse>(
    "cgv",
    queryCgv
  );

  const [layout, cgvPageContent] = await Promise.all([
    layoutPromise,
    cgvPageContentPromise,
  ]);

  return {
    props: {
      intlMessages,
      cgvPageContent,
      layout,
    },
    revalidate: 10,
  };
};

export { Cgv as default } from "@/components/pages/cgv/Cgv";
